import { useEffect, useState } from "react"

const SessionTable = ({ getServiceName, closeModal, setSessionNums }) => {
  const [sessions, setSessions] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function getSessions() {
      setLoading(true)
      const { data } = await $app.axios.get(
        `/services/metadata?service[name]=${getServiceName()}`
      )

      const bahamahost_data = data.metadata?.find(
        m => m.desc == 'bahamahost session desc'
      ) || data.metadata?.find(
        m => m.desc == 'bahamahost companies corporate session desc'
      )

      const nums = bahamahost_data?.data
        ?.filter(d => d.active)
        .map(d => {
          return { label: d.session_numb, value: d.session_numb }
        })

      // console.log('session data: ', bahamahost_data)

      setSessions(bahamahost_data?.data?.filter(d => d.active))
      setSessionNums(nums)
      setLoading(false)
    }

    getSessions()
  }, [getServiceName])

  const rows = sessions.map((session, index) => (
    <tr key={index}>
      <td>{session?.session_type}</td>
      <td>{session?.session_numb}</td>
      <td>{`${session?.month_start} ${session?.date_start} - ${session?.month_end} ${session?.date_end}`}</td>
      <td>{`${session?.time_start} - ${session?.time_end}`}</td>
      <td>{session?.days.join()}</td>
    </tr>
  ))

  return loading ? <p>
      <div className="d-flex">
        <span>Loading sessions...</span>
        <div className='animate-spin'>
          <i className='fas fa-circle-notch' />
        </div>
      </div>
    </p> : (
    <table className='table table-hover'>
      <thead>
        <tr>
          <th scope='col'>Session Type</th>
          <th scope='col'>Session Number</th>
          <th scope='col'>Date</th>
          <th scope='col'>Time</th>
          <th scope='col'>Days Available</th>
        </tr>
      </thead>
      <tbody>{rows}</tbody>
    </table>
  )
}

export default SessionTable
